/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import './account';
import '../../../banking/account_model';
import '../../../connect/v2/resources/error';
import '../../common/identifier/account_scoped_identifier';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "dashboard": {
            "nested": {
              "account": {
                "nested": {
                  "CreateAccountRequest": {
                    "fields": {
                      "idempotenceKey": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "type": {
                        "type": ".squareup.bbfrontend.dashboard.account.AccountType",
                        "id": 2,
                        "rule": "optional"
                      },
                      "name": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "metadata": {
                        "type": ".squareup.bbfrontend.dashboard.account.AccountMetadata",
                        "id": 4,
                        "rule": "optional"
                      }
                    }
                  },
                  "CreateAccountResponse": {
                    "fields": {
                      "account": {
                        "type": ".squareup.banking.Account",
                        "id": 1,
                        "rule": "optional"
                      },
                      "errors": {
                        "type": ".squareup.connect.v2.resources.Error",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  },
                  "DeactivateAccountRequest": {
                    "fields": {
                      "accountId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "DeactivateAccountResponse": {
                    "fields": {
                      "account": {
                        "type": ".squareup.banking.Account",
                        "id": 1,
                        "rule": "optional"
                      },
                      "errors": {
                        "type": ".squareup.connect.v2.resources.Error",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  },
                  "ListAccountsRequest": {
                    "fields": {
                      "owners": {
                        "type": ".squareup.bbfrontend.common.account_scoped_identifier.AccountScopedIdentifier",
                        "id": 1,
                        "rule": "repeated"
                      }
                    }
                  },
                  "ListAccountsResponse": {
                    "fields": {
                      "accounts": {
                        "type": ".squareup.banking.Account",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "errors": {
                        "type": ".squareup.connect.v2.resources.Error",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  },
                  "UpdateAccountRequest": {
                    "fields": {
                      "id": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "idempotenceKey": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "name": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "UpdateAccountResponse": {
                    "fields": {
                      "account": {
                        "type": ".squareup.banking.Account",
                        "id": 1,
                        "rule": "optional"
                      },
                      "errors": {
                        "type": ".squareup.connect.v2.resources.Error",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.account?.nested?.CreateAccountRequest && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.account?.nested?.CreateAccountResponse && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.account?.nested?.DeactivateAccountRequest && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.account?.nested?.DeactivateAccountResponse && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.account?.nested?.ListAccountsRequest && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.account?.nested?.ListAccountsResponse && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.account?.nested?.UpdateAccountRequest && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.account?.nested?.UpdateAccountResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE CreateAccountRequest @ squareup/bbfrontend/dashboardweb/account/account_request_response.proto at 15:1
 */
export const CreateAccountRequest = $root.lookupType('squareup.bbfrontend.dashboard.account.CreateAccountRequest');
fixType(CreateAccountRequest, {
  idempotenceKey: {
    notEmpty: true
  },
  type: {
    required: true
  },
  name: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CreateAccountRequest);
/**
 * SOURCE CreateAccountResponse @ squareup/bbfrontend/dashboardweb/account/account_request_response.proto at 22:1
 */
export const CreateAccountResponse = $root.lookupType('squareup.bbfrontend.dashboard.account.CreateAccountResponse');
fixType(CreateAccountResponse);
Builder.createAndAttachToType(CreateAccountResponse);
/**
 * SOURCE DeactivateAccountRequest @ squareup/bbfrontend/dashboardweb/account/account_request_response.proto at 27:1
 */
export const DeactivateAccountRequest = $root.lookupType('squareup.bbfrontend.dashboard.account.DeactivateAccountRequest');
fixType(DeactivateAccountRequest, {
  accountId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(DeactivateAccountRequest);
/**
 * SOURCE DeactivateAccountResponse @ squareup/bbfrontend/dashboardweb/account/account_request_response.proto at 31:1
 */
export const DeactivateAccountResponse = $root.lookupType('squareup.bbfrontend.dashboard.account.DeactivateAccountResponse');
fixType(DeactivateAccountResponse);
Builder.createAndAttachToType(DeactivateAccountResponse);
/**
 * SOURCE ListAccountsRequest @ squareup/bbfrontend/dashboardweb/account/account_request_response.proto at 36:1
 */
export const ListAccountsRequest = $root.lookupType('squareup.bbfrontend.dashboard.account.ListAccountsRequest');
fixType(ListAccountsRequest, {
  owners: {
    required: true
  }
});
Builder.createAndAttachToType(ListAccountsRequest);
/**
 * SOURCE ListAccountsResponse @ squareup/bbfrontend/dashboardweb/account/account_request_response.proto at 40:1
 */
export const ListAccountsResponse = $root.lookupType('squareup.bbfrontend.dashboard.account.ListAccountsResponse');
fixType(ListAccountsResponse);
Builder.createAndAttachToType(ListAccountsResponse);
/**
 * SOURCE UpdateAccountRequest @ squareup/bbfrontend/dashboardweb/account/account_request_response.proto at 54:1
 */
export const UpdateAccountRequest = $root.lookupType('squareup.bbfrontend.dashboard.account.UpdateAccountRequest');
fixType(UpdateAccountRequest, {
  id: {
    notEmpty: true
  },
  idempotenceKey: {
    notEmpty: true
  },
  name: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(UpdateAccountRequest);
/**
 * SOURCE UpdateAccountResponse @ squareup/bbfrontend/dashboardweb/account/account_request_response.proto at 60:1
 */
export const UpdateAccountResponse = $root.lookupType('squareup.bbfrontend.dashboard.account.UpdateAccountResponse');
fixType(UpdateAccountResponse);
Builder.createAndAttachToType(UpdateAccountResponse);